export { default } from './StyledInput';
